// extracted by mini-css-extract-plugin
module.exports = {"box":"record-surround_box__C_UyC"};